// extracted by mini-css-extract-plugin
export default {"root":"StepEnd_root__JNj5W"};